module.exports = __webpack_public_path__ + "img/card_medicaid_certification.76acfddc.svg";